import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import PackageLog from "./pages/PackageLog";
import LostFound from "./pages/LostFound";
import { SupabaseAuthProvider } from "@/contexts/SupabaseAuthContext";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import { ErrorBoundary } from "./components/ErrorBoundary";

// Create a new QueryClient instance
const queryClient = new QueryClient();

const App = () => {
  console.log("App component rendering");
  
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <SupabaseAuthProvider>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Navigate to="/auth" replace />} />
                <Route path="/auth" element={<Auth />} />
                <Route 
                  path="/dashboard" 
                  element={
                    <ErrorBoundary>
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    </ErrorBoundary>
                  } 
                />
                <Route 
                  path="/packages" 
                  element={
                    <ErrorBoundary>
                      <ProtectedRoute>
                        <PackageLog />
                      </ProtectedRoute>
                    </ErrorBoundary>
                  } 
                />
                <Route 
                  path="/lost-found" 
                  element={
                    <ErrorBoundary>
                      <ProtectedRoute>
                        <LostFound />
                      </ProtectedRoute>
                    </ErrorBoundary>
                  } 
                />
                <Route
                  path="/admin"
                  element={
                    <ErrorBoundary>
                      <ProtectedRoute roles={['admin']}>
                        <Admin />
                      </ProtectedRoute>
                    </ErrorBoundary>
                  } 
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ErrorBoundary>
          </SupabaseAuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
